import Bugsnag from '@bugsnag/js';

import type { MmaSessionFragmentFragment } from '../graphql/mma/generated/graphql';

export interface OnSaveReturn {
  mmaBaseUser: MmaSessionFragmentFragment,
}

const useSaveSesionData = () => {
  const { setUser } = useMmaBaseUser();
  const onSave = (user: MmaSessionFragmentFragment): OnSaveReturn => {
    Bugsnag.addOnError((event) => { event.addMetadata('session', user); });
    setUser(user);
    return {
      mmaBaseUser: user,
    };
  };
  return { onSave };
};

export default useSaveSesionData;
